import { Tag, theme } from 'antd';

import { RuleMessageLevel } from '@app/domain-interfaces';

export type RuleLevelRendererProps = {
  messageLevel?: RuleMessageLevel | null;
};

export const RuleLevelRenderer = ({ messageLevel }: RuleLevelRendererProps) => {
  const { token } = theme.useToken();

  let color = token.colorInfo;
  let label = 'Unknown';

  switch (messageLevel) {
    case RuleMessageLevel.Info:
      color = token.colorInfo;
      label = 'Info';
      break;
    case RuleMessageLevel.Warning:
      color = token.colorWarning;
      label = 'Warning';
      break;
    case RuleMessageLevel.Error:
      color = token.colorError;
      label = 'Error';
      break;
    default:
      break;
  }

  return <Tag color={color}>{label}</Tag>;
};
